enum HeraldiqueType {
    heraldique = 'heraldique',
    administration = 'administration'
  }

export default HeraldiqueType;